import { CLIENTTREE__MUTATIONS } from "../mutation-types";
import { CLIENTTREE__ACTIONS } from '../action-types'
import { CLIENTTREE__API } from '@/_helpers/urls'
import http from "@/_helpers/http";

// State
const state = {
    clienttree: []
};

const getters = {};

// Mutations
const mutations = {
    [CLIENTTREE__MUTATIONS.CLIENTTREE](state, data) {
        state.clienttree = data
    },
};

// Actions
const actions = {
    async [CLIENTTREE__ACTIONS.CLIENTTREE]({ commit }, parameter) {
        try {
            const parent = parameter?.parentID !== undefined && parameter?.parentID !== null ? `${parameter?.parentID}` : '';
            const { data } = await http().get(`${CLIENTTREE__API.CLIENTTREE}?parent=${parent}`);
            commit(CLIENTTREE__MUTATIONS.CLIENTTREE, data?.data);
        } catch (error) {
            console.error("Error fetching client tree:", error);
        }
    }

};

export default {
    strict: process.env.NODE_ENV !== "production",
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
